import { RichTextElement } from "@redotech/redo-model/forge/marketing-signup-forge-types";
import { quillStyles } from "@redotech/redo-model/quill-styles";
import htmlReactParser from "html-react-parser";
import { memo } from "react";

export const RichText = memo(function RichText({
  element,
}: {
  element: RichTextElement;
}) {
  const containerId = `container-${element.id}`;
  return (
    <>
      <style>
        {/* TODO - Find a way to include all the quill styles automatically */}
        {`#${containerId} a {
          color: ${element.linkColor};
        }
        ${quillStyles}
        `}
      </style>
      <div
        id={containerId}
        style={{
          color: element.textColor,
          fontSize: element.fontSizePx,
          fontFamily: element.fontFamily,
          border: "none",
          lineHeight: 1.42, // match Quill Editor
        }}
      >
        {htmlReactParser(element.html)}
      </div>
    </>
  );
});
